import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { MEMBER_ADMIN_ROLES } from '../composables/memberStatus'

const MEMBER_LIST_ROLES = ['Vorstand', 'Admin', 'Users']

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Home,
    meta: {
      requireAuth: false,
      icon: 'home',
      title: 'Start',
    }
  },
  {
    path: '/event-view/:id?',
    name: 'Ausfahrten',

    meta: {
      requireAuth: true,
      icon: 'skiing',
      group: 'Veranstaltungen',
      title: 'Ausfahrten',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "app-participants" */ '../views/Events.vue'),
    children: [
      {
        path: 'participants',
        component: () => import(/* webpackChunkName: "app-participants" */ '../components/participants/Participant.vue'),
        name: 'participantlist'
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "app-participants" */ '../components/events/EventOverview.vue'),
        name: 'eventoverview'
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        path: 'event', component: () => import(/* webpackChunkName: "app-participants" */ '../components/events/Event.vue'),
        name: 'eventconfig'
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        path: 'room-assignment', component: () => import(/* webpackChunkName: "app-participants" */ '../components/rooms/RoomAssignment.vue'),
        name: 'roomconfig',
      }, {
        path: 'course-assignment', component: () => import(/* webpackChunkName: "app-participants" */ '../components/courses/Courses.vue'),
        name: 'courseconfig'
      }, {
        path: 'billing', component: () => import(/* webpackChunkName: "app-participants" */ '../components/events/EventBilling.vue'),
        name: 'eventbilling'
      }
    ]
  },
  {
    path: '/instructor-statistik',
    name: 'Instructor Statistik',
    component: () => import('../views/InstructorStatistics.vue'),
    meta: {
      requireAuth: true,
      icon: 'chart-bar',
      group: 'Veranstaltungen',
      title: 'Lehrkräfte-Statistik',
    }
  },
  {
    path: '/members',
    name: 'Mitglieder',
    component: () => import(/* webpackChunkName: "app-members" */ '../views/Members.vue'),
    meta: {
      requireAuth: true,
      requireRoles: MEMBER_LIST_ROLES,
      icon: 'users',
      group: 'Mitglieder',
      title: 'Mitglieder',
    },
    // Each child is one tab; meta.title is the tab label, meta.requireRoles hides the tab.
    children: [
      {
        path: '',
        name: 'memberoverview',
        component: () => import(/* webpackChunkName: "app-members" */ '../components/members/MembersOverview.vue'),
        meta: { title: 'Übersicht' },
        // Older links opened a member group via /members?group=<id>.
        beforeEnter: (to) => (to.query.group ? { name: 'membergroups', query: to.query } : true),
      },
      {
        path: 'groups',
        name: 'membergroups',
        component: () => import(/* webpackChunkName: "app-members" */ '../components/members/MemberView.vue'),
        meta: { title: 'Mitgliedergruppen', requireRoles: MEMBER_ADMIN_ROLES },
      },
      {
        path: 'list',
        name: 'memberlist',
        component: () => import(/* webpackChunkName: "app-members" */ '../views/Memberslist.vue'),
        meta: { title: 'Mitgliederliste' },
      },
      {
        path: 'annual-billing',
        name: 'annualbilling',
        component: () => import(/* webpackChunkName: "app-members" */ '../views/AnnualBilling.vue'),
        meta: { title: 'Jährliche Abrechnung', requireRoles: MEMBER_ADMIN_ROLES },
      },
    ]
  },
  {
    // Former address of the member list
    path: '/memberlist',
    redirect: { name: 'memberlist' },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
